import $ from 'jquery';
import Masonry from 'masonry-layout';

//Header Flyouts
$(function () {
    $('.navigation-main li.drop').click(function () {
        $(this).find('.level-2').slideToggle();
        $('.navigation-main li.drop').not(this).find('.level-2').slideUp();
    });

    // Back to top "nach oben"
    $('#backtotop').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 800);
    });

    // Back to top opacity von "nach oben"
    var last_opacity = null;
    $(document).scroll(function () {
        var opacity = Math.max(0, Math.min(1, ($(this).scrollTop() - 200) / 100));
        if (last_opacity !== opacity) {
            $('#backtotop').css('opacity', opacity);
            last_opacity = opacity;
            if (opacity === 0) {
                $('#backtotop').css('display', 'none');
            } else {
                $('#backtotop').css('display', 'block');
            }
        }
    });

    // Mobile Navigation
    if (!$('.headertop .navigation-mobile-button').hasClass('open')) {
        $('.headermobile #navigation-mobile-content').hide();
    }
    $('.headertop .navigation-mobile-button').click(function () {
        $('#header').toggleClass('menu-open');
        $('.headertop .navigation-mobile-button').toggleClass('open');
        if ($('.headertop .navigation-mobile-button').hasClass('open')) {
            $('.headermobile #navigation-mobile-content').slideDown();
        } else {
            $('.headermobile #navigation-mobile-content').slideUp();
        }
    });

    // Header Up - Down + Mobilefilter
    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        if ($(window).scrollTop() > 60) {
            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                $('#header').addClass('up');
                $('.magazinfilterlink-bot').addClass('up');
                $('.agendafilterlink-bot').addClass('up');
                $('.kulturplatzfilterlink-bot').addClass('up');
            } else {
                $('#header').removeClass('up');
                $('.magazinfilterlink-bot').removeClass('up');
                $('.agendafilterlink-bot').removeClass('up');
                $('.kulturplatzfilterlink-bot').removeClass('up');
            }
            lastScrollTop = st;
        }

        if ($(window).width() < 940) {
            if ($(window).scrollTop() === 0) {
                $('.magazinfilterlink-bot').fadeOut();
                $('.agendafilterlink-bot').fadeOut();
                $('.kulturplatzfilterlink-bot').fadeOut();
            } else {
                $('.magazinfilterlink-bot').fadeIn();
                $('.agendafilterlink-bot').fadeIn();
                $('.kulturplatzfilterlink-bot').fadeIn();
            }
        }
    });

    // Mobile Filter Menu Toggle
    $('#magazinPage_index .filtern').click(function () {
        $('#main .magazinfilter').fadeIn('fast');
        $('html, body').css({ overflowY: 'scroll' });
    });
    $('#agendaPage_index .filtern').click(function () {
        $('#main .agendafilter').fadeIn('fast');
        $('html, body').css({ overflowY: 'scroll' });
    });
    $('#kulturplatzPage_index .filtern').click(function () {
        $('#main .kulturplatzfilter').fadeIn('fast');
        $('html, body').css({ overflowY: 'scroll' });
    });

    $('.magazinfilter .mobile-filter-close').click(function () {
        $(this).parents('.magazinfilter').fadeOut('fast');
        $('.headertop .navigation-mobile-button').removeClass('open');
        $('#header').removeClass('menu-open');
        $('.headermobile #navigation-mobile-content').slideUp();
        $('html, body').css({ overflowY: '' });
    });
    $('.agendafilter .mobile-filter-close').click(function () {
        $(this).parents('.agendafilter').fadeOut('fast');
        $('.headertop .navigation-mobile-button').removeClass('open');
        $('#header').removeClass('menu-open');
        $('.headermobile #navigation-mobile-content').slideUp();
        $('html, body').css({ overflowY: '' });
    });
    $('.kulturplatzfilter .mobile-filter-close').click(function () {
        $(this).parents('.kulturplatzfilter').fadeOut('fast');
        $('.headertop .navigation-mobile-button').removeClass('open');
        $('#header').removeClass('menu-open');
        $('.headermobile #navigation-mobile-content').slideUp();
        $('html, body').css({ overflowY: '' });
    });

    // Filter Accordion Toggle
    $('.accordion .accordion-toggler, .inhalt-accordion .accordion-toggler').each(function () {
        if ($(this).hasClass('open')) {
            $(this).addClass('openbg');
        }
    });
    $('.accordion .accordion-toggler, .inhalt-accordion .accordion-toggler').click(function () {
        $(this).toggleClass('openbg');
        $(this).next('.accordion-content').slideToggle();
        $(this).prev('.accordion-content').slideToggle();
        /*if($(this).hasClass('open')) {
			$(this).next('.accordion-content').slideDown();
			$(this).prev('.accordion-content').slideDown();
		} else {
			$(this).next('.accordion-content').slideUp();
			$(this).prev('.accordion-content').slideUp();
		}*/
    });

    // Mobile Filter Accept - Close
    $('.filteracceptmobile').click(function () {
        $('#main .magazinfilter').fadeOut('fast');
        $('.headertop .navigation-mobile-button').removeClass('open');
        $('#header').removeClass('menu-open');
        $('.headermobile #navigation-mobile-content').slideUp();
        $('html, body').css({ overflowY: '' });
    });
    $('.filteracceptmobile').click(function () {
        $('#main .agendafilter').fadeOut('fast');
        $('.headertop .navigation-mobile-button').removeClass('open');
        $('#header').removeClass('menu-open');
        $('.headermobile #navigation-mobile-content').slideUp();
        $('html, body').css({ overflowY: '' });
    });
    $('.filteracceptmobile').click(function () {
        $('#main .kulturplatzfilter').fadeOut('fast');
        $('.headertop .navigation-mobile-button').removeClass('open');
        $('#header').removeClass('menu-open');
        $('.headermobile #navigation-mobile-content').slideUp();
        $('html, body').css({ overflowY: '' });
    });

    // Magazin-Detail umsortieren Mobile
    if ($(window).width() < 940) {
        $('#magazinPage_get .autorprofil').insertAfter($('#magazinPage_get .detailshare'));
        $('#magazinPage_get .autorprofil .interessen-autor').prependTo($('#magazinPage_get .autorprofil'));
        $('#magazinPage_get .autorprofil .ressorts-autor').prependTo($('#magazinPage_get .autorprofil'));
        $('#magazinPage_get .dazugehoerige').insertAfter($('#magazinPage_get .autorprofil'));
        $('#magazinPage_get .aehnliche-magazin').insertAfter($('#magazinPage_get .dazugehoerige'));
    }

    // Agenda-Detail umsortieren Mobile
    if ($(window).width() < 940) {
        $('#agendaPage_get .detailshare').insertAfter($('#agendaPage_get .veranstaltungsort-google-map'));
    }

    // Kulturplatz-Hinweis anzeigen, wenn kein localStorage-Eintrag vorhanden:
    if (window.localStorage) {
        let kulturplatz_hinweis_accepted = window.localStorage.getItem('tgk-kulturplatz-hinweis');
        if (!kulturplatz_hinweis_accepted) {
            $('.kulturplatzhinweis').show();
        }
    }

    // Kulturplatz Hinweis ausblenden
    $('.kulturplatzhinweis .verstanden').on('click', function () {
        $('.kulturplatzhinweis').fadeOut();
        if (window.localStorage) {
            window.localStorage.setItem('tgk-kulturplatz-hinweis', 'declined');
        }
        return false;
    });

    // Topper
    let seenTopper = function (topperId) {
        if (window.localStorage && topperId) {
            let seenbanners = JSON.parse(window.localStorage.getItem('tgk-seen-toppers') || null) || [];
            seenbanners.push(topperId);
            window.localStorage.setItem('tgk-seen-toppers', JSON.stringify(seenbanners));
        }
    };

    // Show all toppers that do NOT appear in the tgk-seen-toppers array: The toppers are display:none by default:
    if (window.localStorage) {
        let toppers = JSON.parse(window.localStorage.getItem('tgk-seen-toppers') || null) || [];
        $('.topper').each(function () {
            let topperEl = $(this);
            let id = topperEl.attr('data-banner-id');
            if (toppers.indexOf(id) === -1) {
                topperEl.show();
            }
        });
    }
    let topperheader;
    if ($(window).width() > 940) {
        if ($('.headertop .topper').length) {
            topperheader = $('#header').outerHeight();
            let naviabstand = null;
            if ($('#header .headerbot').length) {
                naviabstand = topperheader - $('#header .headerbot').height();
            } else {
                naviabstand = topperheader;
            }
            $('#header').addClass('topperup');
            $('#main').addClass('topperup');
            $('#homePage_index .slider').addClass('topperup');
            $('#service .servicetitle').addClass('topperup');
            $('#homePage_index #main .magazin').addClass('topperup');
            $('#header .headertop nav ul.level-1 .level-2').css('top', naviabstand);
        }
        $('.topper .close').click(function () {
            seenTopper($(this).parents('.topper').attr('data-banner-id'));
            $('.topper').fadeOut();
            $('#header').removeClass('topperup');
            $('#main').removeClass('topperup');
            $('#homePage_index .slider').removeClass('topperup');
            $('#service .servicetitle').removeClass('topperup');
            $('#homePage_index #main .magazin').removeClass('topperup');
            $('#header .headertop nav ul.level-1 .level-2').css('top', 101);
        });
    } else {
        if ($('.headertop .topper').length) {
            topperheader = $('#header').outerHeight();
            let naviabstand = null;
            if ($('#header .headerbot').lenght) {
                naviabstand = topperheader - $('#header .headerbot').height();
            } else {
                naviabstand = topperheader;
            }
            $('#header').addClass('topperup');
            $('#main').css('paddingTop', topperheader + 10);
            $('#header .headertop nav ul.level-1 .level-2').css('top', naviabstand);
        } else {
            topperheader = $('#header').outerHeight();
            $('.topper').fadeOut();
            $('#header').removeClass('topperup');
            $('#main').css('paddingTop', topperheader);
            $('#header .headertop nav ul.level-1 .level-2').css('top', 101);
        }
        $('.topper .close').click(function () {
            seenTopper($(this).parents('.topper').attr('data-banner-id'));
            let topperheader = $('#header').outerHeight();
            let onlytopper = $('#header .topper').outerHeight();
            let onlyheader = topperheader - onlytopper;
            $('.topper').fadeOut();
            $('#header').removeClass('topperup');
            $('#main').css('paddingTop', onlyheader + 10);
            $('#header .headertop nav ul.level-1 .level-2').css('top', 101);
        });
    }

    $(window).scroll(function () {
        if ($('#header').hasClass('up') && $('#header').hasClass('topperup')) {
            $('#header').css('top', topperheader * -1 + 48);
        } else if ($('#header').hasClass('up')) {
            $('#header').css('top', -60);
        } else {
            $('#header').css('top', 0);
        }
    });

    // Tipp Banner verschieben auf Detailseiten
    /*
    if ($(window).width() > 940) {
        let hoeherechts = $('.b30.last').height();
        let hoehelinks = $('.b60.first').height();

        if (hoeherechts > hoehelinks) {
            $('.b30.last .tipp-banner-container').appendTo('.b60.first');
        }
    } else {
        $('.b30.last .tipp-banner-container .tipp-banner:first').insertAfter('.detailshare');
        $('.b30.last .tipp-banner-container .tipp-banner:first').insertAfter('.werbungbox:last');
        $('.b30.last .tipp-banner-container').appendTo('#main');
    }
    */

    // Home Slider umsortieren Mobile
    if ($(window).width() < 940) {
        $('#homePage_index .slider').removeClass('topperup');
        $('#homePage_index #main .magazinfilterlink').first().after($('#homePage_index .slider'));
    }

    // Servicetop umsortieren Mobile
    if ($(window).outerWidth() < 950) {
        $('.servicetitle').prependTo($('#main'));
    }

    // newsletter modal
    // show after n seconds, if:
    // - not from newsletter (url: ?utm_source=newsletter)
    // - not already clicked away
    setTimeout(() => {
        // utm source check is delivered from backend: window.GLOBALS.from_newsletter == true
        if (window.GLOBALS && window.GLOBALS.from_newsletter) {
            // user comes from newsletter referrer, no info modal:
            return;
        }
        if (localStorage && localStorage.getItem('tgk_newsletter_modal_dismissed') === 'true') {
            // user dismissed newsletter modal already, no info modal:
            return;
        }
        // Now here we show the modal
        $('#newsletterpopup').addClass('open');
        $('#newsletterpopup .popup-close').click(function () {
            if (localStorage) {
                localStorage.setItem('tgk_newsletter_modal_dismissed', 'true');
            }
            $('#newsletterpopup').removeClass('open');
        });
    }, 60000);

    //Masonry
    if ($('.tipp-banner-container').length) {
        new Masonry('.tipp-banner-container', {
            // set itemSelector so .grid-sizer is not used in layout
            itemSelector: '.tipp-banner',
            // use element for option
            columnWidth: '.tipp-banner',
            gutter: '.gutter-sizer',
            percentPosition: true,
        });
    }
});

//Neu laden bei Tablet / Smartphone drehen
$(window).on('orientationchange', function () {
    location.reload();
});
